import React, { useState } from "react";
import homepageData from "../../utils/data/homepage.json";
import Buttons from "../../components/Elements/Buttons";
import DonationPopup from "../../components/DonationPopup";

const Missions = () => {
  const { missions } = homepageData;
  const [isDonationPopupOpen, setIsDonationPopupOpen] = useState(false);
  const [selectedMission, setSelectedMission] = useState("");

  const handleMissionClick = (missionTitle) => {
    setSelectedMission(missionTitle);
    setIsDonationPopupOpen(true);
  };

  const handleDonateNowClick = () => {
    setSelectedMission("");
    setIsDonationPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsDonationPopupOpen(false);
    setSelectedMission("");
  };

  return (
    <div className="bg-[#FFF8E6] pb-20">
      {/* Title & Description */}
      <div className="text-center pt-20">
        <p className="text-4xl font-source-serif-4 text-[#67142D] font-semibold">
          पवित्र संकल्प में आपका सहयोग
        </p>
        <p className="font-inter text-[#4A4A4A] text-[20px] mt-2">
        विश्व सनातन महापीठ के माध्यम से हम शिक्षा, स्वास्थ्य, पर्यावरण,
        और धर्म-संरक्षण के कार्यों द्वारा समाज में प्रकाश फैला रहे हैं।
        </p>
      </div>

      {/* Mission Cards */}
      <div className="mt-12 px-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
        {missions.map((mission, index) => (
          <div
            key={index}
            onClick={() => handleMissionClick(mission.title)}
            className="bg-white w-[394px] rounded-xl transition-shadow duration-300 hover:shadow-lg cursor-pointer hover:scale-105 transform transition-all duration-300"
          >
            <img
              src={mission.cardImage}
              alt={mission.title}
              className="w-full h-[280px] p-5 rounded-xl object-contain"
            />
            <p className="text-center text-[#67142D] font-source-serif-4 font-semibold pb-2 text-2xl">
              {mission.title}
            </p>
            <p className="text-center text-[#4A4A4A] font-inter font-medium pb-5 text-lg">
              {mission.price === 0 ? "Select Amount" : `₹${mission.price.toLocaleString('en-IN')}`}
            </p>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <button onClick={handleDonateNowClick}>
          <Buttons
            textColor="white"
            color="red"
            buttonText={"Donate Now"}
          />
        </button>
      </div>

      {/* Donation Popup with Pre-selected Mission */}
      <DonationPopup 
        isOpen={isDonationPopupOpen} 
        onClose={handleClosePopup}
        preSelectedMission={selectedMission}
      />
    </div>
  );
};

export default Missions;
